// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .customer-admin-home-page{
        margin: 0px;
        padding: 0px;
        height: 100vh;
        box-sizing: border-box;
        font-family:Verdana, Geneva, Tahoma, sans-serif;
    }
    .customer-admin-home-page-layout{
        height: 90%;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: auto 1fr;
    }
    .customer-admin-home-page-parent-container{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .customer-admin-home-page-container h2{
        text-align: center;
        font-weight: 500;
        color: rgb(90, 90, 90);
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .customer-admin-home-page-grid{
        padding: 10px 20px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        column-gap: 20px;
        row-gap: 20px;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .customer-admin-home-page-grid div{
        cursor: pointer;
        padding: 0px 20px;
        padding-bottom: 10vh;
        border-radius: 4px;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
    }
    .customer-admin-home-page-grid div:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 20px rgba(0,0,0,0.2);
    }
    .customer-admin-home-page-grid div:nth-child(1) {
        background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
    }

    .customer-admin-home-page-grid div:nth-child(2) {
        background: linear-gradient(135deg, #1f4037 0%, #99f2c8 100%); /* muted green */
    }

    .customer-admin-home-page-grid div:nth-child(3) {
        background: linear-gradient(135deg, #3a7bd5 0%, #3a6073 100%); /* blue-gray */
    }

    .customer-admin-home-page-grid div:nth-child(4) {
        background: linear-gradient(135deg, #833ab4 0%, #fd1d1d 100%); /* darker magenta-red */
    }

    .customer-admin-home-page-grid div:nth-child(5) {
        background: linear-gradient(135deg, #414d0b 0%, #727a17 100%); /* olive green */
    }

    .customer-admin-home-page-grid div:nth-child(6) {
        background: linear-gradient(135deg, #0f2027 0%, #2c5364 100%); /* dark teal */
    }

    .customer-admin-home-page-grid div:nth-child(7) {
        background: linear-gradient(135deg, #42275a 0%, #734b6d 100%); /* dark purple */
    }

    .customer-admin-home-page-grid div:nth-child(8) {
        background: linear-gradient(135deg, #004e92 0%, #000428 100%); /* navy blue */
    }
    .customer-admin-home-page-grid h2{
        color: white;
        margin-top: 8vh;
        margin-bottom: 4vh;
        font-weight: 600;
        font-size: 20px;
        text-align: center;
    }
    .customer-admin-home-page-grid p{
        color: #dadada;
        text-align: center;
    }
}
@media screen and (max-width:949px){
    .customer-admin-home-page{
        margin: 0px;
        padding: 0px;
        height: 100vh;
        box-sizing: border-box;
        font-family:Verdana, Geneva, Tahoma, sans-serif;
    }
    .customer-admin-home-page-layout{
        height: 90%;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: auto 1fr;
    }
    .customer-admin-home-page-parent-container{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .customer-admin-home-page-container h2{
        text-align: center;
        font-weight: 500;
        color: rgb(90, 90, 90);
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .customer-admin-home-page-grid{
        padding: 10px 20px;
        display: grid;
        grid-template-columns: 1fr;
        column-gap: 20px;
        row-gap: 20px;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .customer-admin-home-page-grid div{
        cursor: pointer;
        padding: 0px 20px;
        padding-bottom: 10vh;
        border-radius: 4px;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
    }
    .customer-admin-home-page-grid div:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 20px rgba(0,0,0,0.2);
    }
    .customer-admin-home-page-grid div:nth-child(1) {
        background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
    }

    .customer-admin-home-page-grid div:nth-child(2) {
        background: linear-gradient(135deg, #1f4037 0%, #99f2c8 100%); /* muted green */
    }

    .customer-admin-home-page-grid div:nth-child(3) {
        background: linear-gradient(135deg, #3a7bd5 0%, #3a6073 100%); /* blue-gray */
    }

    .customer-admin-home-page-grid div:nth-child(4) {
        background: linear-gradient(135deg, #833ab4 0%, #fd1d1d 100%); /* darker magenta-red */
    }

    .customer-admin-home-page-grid div:nth-child(5) {
        background: linear-gradient(135deg, #414d0b 0%, #727a17 100%); /* olive green */
    }

    .customer-admin-home-page-grid div:nth-child(6) {
        background: linear-gradient(135deg, #0f2027 0%, #2c5364 100%); /* dark teal */
    }

    .customer-admin-home-page-grid div:nth-child(7) {
        background: linear-gradient(135deg, #42275a 0%, #734b6d 100%); /* dark purple */
    }

    .customer-admin-home-page-grid div:nth-child(8) {
        background: linear-gradient(135deg, #004e92 0%, #000428 100%); /* navy blue */
    }
    .customer-admin-home-page-grid h2{
        color: white;
        margin-top: 8vh;
        margin-bottom: 4vh;
        font-weight: 600;
        font-size: 20px;
        text-align: center;
    }
    .customer-admin-home-page-grid p{
        color: #dadada;
        text-align: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/CustomerAdministratorStyles/HomePage/HomePage.css"],"names":[],"mappings":"AAAA;IACI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,+CAA+C;IACnD;IACA;QACI,WAAW;QACX,sBAAsB;QACtB,aAAa;QACb,+BAA+B;IACnC;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,sBAAsB;QACtB,4DAA4D;IAChE;IACA;QACI,kBAAkB;QAClB,aAAa;QACb,sCAAsC;QACtC,gBAAgB;QAChB,aAAa;QACb,4DAA4D;IAChE;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,oBAAoB;QACpB,kBAAkB;QAClB,0CAA0C;IAC9C;IACA;QACI,2BAA2B;QAC3B,sCAAsC;IAC1C;IACA;QACI,6DAA6D;IACjE;;IAEA;QACI,6DAA6D,EAAE,gBAAgB;IACnF;;IAEA;QACI,6DAA6D,EAAE,cAAc;IACjF;;IAEA;QACI,6DAA6D,EAAE,uBAAuB;IAC1F;;IAEA;QACI,6DAA6D,EAAE,gBAAgB;IACnF;;IAEA;QACI,6DAA6D,EAAE,cAAc;IACjF;;IAEA;QACI,6DAA6D,EAAE,gBAAgB;IACnF;;IAEA;QACI,6DAA6D,EAAE,cAAc;IACjF;IACA;QACI,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,cAAc;QACd,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,+CAA+C;IACnD;IACA;QACI,WAAW;QACX,sBAAsB;QACtB,aAAa;QACb,+BAA+B;IACnC;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,sBAAsB;QACtB,4DAA4D;IAChE;IACA;QACI,kBAAkB;QAClB,aAAa;QACb,0BAA0B;QAC1B,gBAAgB;QAChB,aAAa;QACb,4DAA4D;IAChE;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,oBAAoB;QACpB,kBAAkB;QAClB,0CAA0C;IAC9C;IACA;QACI,2BAA2B;QAC3B,sCAAsC;IAC1C;IACA;QACI,6DAA6D;IACjE;;IAEA;QACI,6DAA6D,EAAE,gBAAgB;IACnF;;IAEA;QACI,6DAA6D,EAAE,cAAc;IACjF;;IAEA;QACI,6DAA6D,EAAE,uBAAuB;IAC1F;;IAEA;QACI,6DAA6D,EAAE,gBAAgB;IACnF;;IAEA;QACI,6DAA6D,EAAE,cAAc;IACjF;;IAEA;QACI,6DAA6D,EAAE,gBAAgB;IACnF;;IAEA;QACI,6DAA6D,EAAE,cAAc;IACjF;IACA;QACI,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,cAAc;QACd,kBAAkB;IACtB;AACJ","sourcesContent":["@media screen and (min-width:950px){\r\n    .customer-admin-home-page{\r\n        margin: 0px;\r\n        padding: 0px;\r\n        height: 100vh;\r\n        box-sizing: border-box;\r\n        font-family:Verdana, Geneva, Tahoma, sans-serif;\r\n    }\r\n    .customer-admin-home-page-layout{\r\n        height: 90%;\r\n        box-sizing: border-box;\r\n        display: grid;\r\n        grid-template-columns: auto 1fr;\r\n    }\r\n    .customer-admin-home-page-parent-container{\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n    .customer-admin-home-page-container h2{\r\n        text-align: center;\r\n        font-weight: 500;\r\n        color: rgb(90, 90, 90);\r\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    }\r\n    .customer-admin-home-page-grid{\r\n        padding: 10px 20px;\r\n        display: grid;\r\n        grid-template-columns: 1fr 1fr 1fr 1fr;\r\n        column-gap: 20px;\r\n        row-gap: 20px;\r\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    }\r\n    .customer-admin-home-page-grid div{\r\n        cursor: pointer;\r\n        padding: 0px 20px;\r\n        padding-bottom: 10vh;\r\n        border-radius: 4px;\r\n        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);\r\n    }\r\n    .customer-admin-home-page-grid div:hover {\r\n        transform: translateY(-5px);\r\n        box-shadow: 0 8px 20px rgba(0,0,0,0.2);\r\n    }\r\n    .customer-admin-home-page-grid div:nth-child(1) {\r\n        background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);\r\n    }\r\n\r\n    .customer-admin-home-page-grid div:nth-child(2) {\r\n        background: linear-gradient(135deg, #1f4037 0%, #99f2c8 100%); /* muted green */\r\n    }\r\n\r\n    .customer-admin-home-page-grid div:nth-child(3) {\r\n        background: linear-gradient(135deg, #3a7bd5 0%, #3a6073 100%); /* blue-gray */\r\n    }\r\n\r\n    .customer-admin-home-page-grid div:nth-child(4) {\r\n        background: linear-gradient(135deg, #833ab4 0%, #fd1d1d 100%); /* darker magenta-red */\r\n    }\r\n\r\n    .customer-admin-home-page-grid div:nth-child(5) {\r\n        background: linear-gradient(135deg, #414d0b 0%, #727a17 100%); /* olive green */\r\n    }\r\n\r\n    .customer-admin-home-page-grid div:nth-child(6) {\r\n        background: linear-gradient(135deg, #0f2027 0%, #2c5364 100%); /* dark teal */\r\n    }\r\n\r\n    .customer-admin-home-page-grid div:nth-child(7) {\r\n        background: linear-gradient(135deg, #42275a 0%, #734b6d 100%); /* dark purple */\r\n    }\r\n\r\n    .customer-admin-home-page-grid div:nth-child(8) {\r\n        background: linear-gradient(135deg, #004e92 0%, #000428 100%); /* navy blue */\r\n    }\r\n    .customer-admin-home-page-grid h2{\r\n        color: white;\r\n        margin-top: 8vh;\r\n        margin-bottom: 4vh;\r\n        font-weight: 600;\r\n        font-size: 20px;\r\n        text-align: center;\r\n    }\r\n    .customer-admin-home-page-grid p{\r\n        color: #dadada;\r\n        text-align: center;\r\n    }\r\n}\r\n@media screen and (max-width:949px){\r\n    .customer-admin-home-page{\r\n        margin: 0px;\r\n        padding: 0px;\r\n        height: 100vh;\r\n        box-sizing: border-box;\r\n        font-family:Verdana, Geneva, Tahoma, sans-serif;\r\n    }\r\n    .customer-admin-home-page-layout{\r\n        height: 90%;\r\n        box-sizing: border-box;\r\n        display: grid;\r\n        grid-template-columns: auto 1fr;\r\n    }\r\n    .customer-admin-home-page-parent-container{\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n    .customer-admin-home-page-container h2{\r\n        text-align: center;\r\n        font-weight: 500;\r\n        color: rgb(90, 90, 90);\r\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    }\r\n    .customer-admin-home-page-grid{\r\n        padding: 10px 20px;\r\n        display: grid;\r\n        grid-template-columns: 1fr;\r\n        column-gap: 20px;\r\n        row-gap: 20px;\r\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    }\r\n    .customer-admin-home-page-grid div{\r\n        cursor: pointer;\r\n        padding: 0px 20px;\r\n        padding-bottom: 10vh;\r\n        border-radius: 4px;\r\n        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);\r\n    }\r\n    .customer-admin-home-page-grid div:hover {\r\n        transform: translateY(-5px);\r\n        box-shadow: 0 8px 20px rgba(0,0,0,0.2);\r\n    }\r\n    .customer-admin-home-page-grid div:nth-child(1) {\r\n        background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);\r\n    }\r\n\r\n    .customer-admin-home-page-grid div:nth-child(2) {\r\n        background: linear-gradient(135deg, #1f4037 0%, #99f2c8 100%); /* muted green */\r\n    }\r\n\r\n    .customer-admin-home-page-grid div:nth-child(3) {\r\n        background: linear-gradient(135deg, #3a7bd5 0%, #3a6073 100%); /* blue-gray */\r\n    }\r\n\r\n    .customer-admin-home-page-grid div:nth-child(4) {\r\n        background: linear-gradient(135deg, #833ab4 0%, #fd1d1d 100%); /* darker magenta-red */\r\n    }\r\n\r\n    .customer-admin-home-page-grid div:nth-child(5) {\r\n        background: linear-gradient(135deg, #414d0b 0%, #727a17 100%); /* olive green */\r\n    }\r\n\r\n    .customer-admin-home-page-grid div:nth-child(6) {\r\n        background: linear-gradient(135deg, #0f2027 0%, #2c5364 100%); /* dark teal */\r\n    }\r\n\r\n    .customer-admin-home-page-grid div:nth-child(7) {\r\n        background: linear-gradient(135deg, #42275a 0%, #734b6d 100%); /* dark purple */\r\n    }\r\n\r\n    .customer-admin-home-page-grid div:nth-child(8) {\r\n        background: linear-gradient(135deg, #004e92 0%, #000428 100%); /* navy blue */\r\n    }\r\n    .customer-admin-home-page-grid h2{\r\n        color: white;\r\n        margin-top: 8vh;\r\n        margin-bottom: 4vh;\r\n        font-weight: 600;\r\n        font-size: 20px;\r\n        text-align: center;\r\n    }\r\n    .customer-admin-home-page-grid p{\r\n        color: #dadada;\r\n        text-align: center;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
